/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_REPORT_SETTINGS (state, reportSettings) {
    state.reportSettings = reportSettings
  },
  REMOVE_RECORD (state, itemId) {
    const reportSetting = state.reportSettings.findIndex((u) => u.id === itemId)
    state.reportSettings.splice(reportSetting, 1)
  }
}
